import angular from 'angular';
import { AdpImportFileExporterModule } from './adp-import-file-exporter/adp-import-file-exporter.module';
import { AssignPayrollsComponent } from './assign-payrolls.component';
import { dashboardPayrollProcessingItemTemplate, dashboardPayrollProcessingListItemTemplate } from './dashboard-payroll-processing-templates.block';
import { PayrollProcessingRoutingModule } from './payroll-processing-routing.module';
import { PayrollProcessorDashboardComponent } from './payroll-processor-dashboard.component';
import { ProcessedPayrollsComponent } from './processed-payrolls.component';
import { WorkingOnPayrollsComponent } from './working-on-payrolls.component';

/** A module that displays components used for processing submitted payrolls. */
export const PayrollProcessingModule = angular
    .module("apex.mainApp.payroll.processing", [
        AdpImportFileExporterModule,
        PayrollProcessingRoutingModule
    ])
    .component("apexPayrollProcessorDashboard", PayrollProcessorDashboardComponent)
    .component("apexAssignPayrolls", AssignPayrollsComponent)
    .component("apexProcessedPayrolls", ProcessedPayrollsComponent)
    .component("apexWorkingOnPayrolls", WorkingOnPayrollsComponent)
    .run(dashboardPayrollProcessingItemTemplate)
    .run(dashboardPayrollProcessingListItemTemplate)
    .name
